import { ref, useContext } from "@nuxtjs/composition-api";
function useFetchFaqs() {
  const { $api } = useContext();
  const faqs = ref();
  const fetchFaqs = async (productId) => {
    try {
      const { data } = await $api.faqsService.getAllFaqs({
        product_id: productId
      });
      if (!data)
        return;
      faqs.value = data;
    } catch (e) {
      console.error("Fetch faqs failed: ", e);
    }
  };
  return { faqs, fetchFaqs };
}
var useFetchFaqs_default = useFetchFaqs;
export {
  useFetchFaqs_default as default
};
